import { UPDATE_BASE_TABLE, FLUSH_QUERY } from "../../actions/QueryBuilder/actionConstants";

const baseTable = (state = "", action) => {
	/**
	 * action: {
	 *  type
	 *  tableName
	 * }
	 */
	switch (action.type) {
		case UPDATE_BASE_TABLE:
			return action.tableName;
		case FLUSH_QUERY:
			return "";
		default:
			return state;
	}
};

export default baseTable;
